import React from 'react';
import Sidebar from '../Sidebar';

const Debit = () => {
  return (
    <div className='flex gap-3'>
      <Sidebar />
      Get all account Debits
    </div>
  );
};

export default Debit;
